import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Table, Tooltip, Image } from "antd";
import axios from "axios";
import { UserInfo } from "../../../../context";
import moment from "moment";
import { FileImageOutlined } from "@ant-design/icons";

const ConfirmList = () => {
  const [subscriptionList, setSubscriptionList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [visible, setVisible] = useState({ open: false, id: null });
  const scaleStep = 0.5;

  const columns = [
    {
      title: "Applied Date",
      dataIndex: "created_at",
      render: (text, record) => (
        <p>
          {moment(new Date(text), "YYYY-MM-DD").format("MMMM DD, YYYY HH:mm")}
        </p>
      ),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      render: (text, record) => <p>{text}</p>,
    },

    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.subscriptionpaymentmerchantinfo.reg_firstname !== null
            ? text.subscriptionpaymentmerchantinfo.reg_firstname
            : ""}{" "}
          {text.subscriptionpaymentmerchantinfo.reg_lastname !== null
            ? text.subscriptionpaymentmerchantinfo.reg_lastname
            : ""}
        </p>
      ),
    },
    {
      title: "Email",
      render: (text) => <p>{text.subscriptionpaymentuser.email}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <div>
          <Tooltip title="Payment Attachment">
            <div
              style={{
                display: "none",
              }}
            >
              <Image
                width={200}
                src=""
                preview={{
                  visible: visible.id === text.id ? visible.open : false,
                  scaleStep,
                  src: `${import.meta.env.VITE_API_IMAGE}subscription-payment/${
                    text.payment_screenshot
                  }`,
                  onVisibleChange: (value) => {
                    setVisible({ ...visible, open: value });
                  },
                }}
                alt="payment-img"
              />
            </div>

            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setVisible({ open: true, id: text.id });
              }}
              icon={<FileImageOutlined />}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getSubscriptionList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 0 };
    axios
      .get("user/admin/subscription-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSubscriptionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getSubscriptionList();
  }, [getSubscriptionList]);

  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={
          subscriptionList.data.length > 0 ? subscriptionList.data : []
        }
        scroll={scroll}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default ConfirmList;
